import type { Address } from '../../../types';
import type { RateCalculationTestRequest, CarrierRateSelectionResponseMap } from './types';
import uuid from 'uuid-random';

export const getLowestCostCarrierRateSelection = (carrierRateSelectionResponseMap: CarrierRateSelectionResponseMap) => {
  const records = Object.values(carrierRateSelectionResponseMap);
  let lowest = records[0];
  for (const record of Object.values(carrierRateSelectionResponseMap)) {
    const lowestCost = lowest.carrierSelection?.carrierDecision.carrierEstimatedPriceDetails.totalCost;
    const recordCost = record.carrierSelection?.carrierDecision.carrierEstimatedPriceDetails.totalCost;
    if (!lowestCost) {
      lowest = record;
      continue;
    }
    if (!recordCost) {
      continue;
    }
    if (recordCost < lowestCost) {
      lowest = record;
    }
  }

  return lowest;
};

export const createShipmentRequestPayloads = (request: RateCalculationTestRequest) => {
  const payloads: any[] = [];
  const shipmentTag = `test-${Date.now()}`;
  const createPayloadForShipment = (fromAddress?: Address) => {
    const id = uuid();
    return {
      partnerShipmentId: id,
      fulfillmentContext: request.fulfillmentContext,
      shippedDateTime: request.shipmentEffectiveDate || new Date().toISOString(),
      orderedDateTime: request.shipmentEffectiveDate || new Date().toISOString(),
      deliverySignatureOption: request.deliverySignatureOption,
      referenceIdentifier: request.referenceIdentifier,
      saturdayDelivery: request.saturdayDelivery,
      shipOption: request.shipOption,
      desiredDeliveryDate: request.desiredDeliveryDate,
      businessDaysOfTransit: request.businessDaysOfTransit,
      shipmentTags: [...(request.shipmentTags ?? []), shipmentTag],
      ...(request?.customsInfo
        ? {
            customsInfo: {
              customsDescription: request?.customsInfo?.customsDescription,
              totalCustomsValue: request?.customsInfo?.totalCustomsValue,
              totalCustomsValueCurrency: request?.customsInfo?.totalCustomsValueCurrency,
            },
          }
        : {}),
      destinationAddress: {
        ...request.shipmentDestinationAddress,
        name: request.shipmentDestinationAddress?.name || 'N/A',
        street1: request.shipmentDestinationAddress?.address1,
        street2: request.shipmentDestinationAddress?.address2,
        countryCode: request.shipmentDestinationAddress?.country,
        company: request.shipmentDestinationAddress?.companyName || 'NA',
        phoneNumber: request.shipmentDestinationAddress?.phoneNumber,
      },
      shipFromAddress: {
        ...request.shipmentSourceAddress,
        name: fromAddress?.name || 'N/A',
        street1: fromAddress?.address1,
        street2: fromAddress?.address2,
        city: fromAddress?.city,
        state: fromAddress?.state,
        postalCode: fromAddress?.postalCode,
        addressType: fromAddress?.addressType,
        company: fromAddress?.companyName || 'N/A',
        countryCode: fromAddress?.country,
        phoneNumber: fromAddress?.phoneNumber,
      },
      orderItemQuantities: [
        {
          productDetails: request.unsupportedProductDetails || [],
          productId: '123456',
          quantity: 1,
          hazmat: request.hazmatParams?.hazmat,
          hazmatInfo: {
            ...(request.hazmatParams || {}),
          },
        },
      ],
      packagingType: {
        packagingMaterial: request.packagingMaterial,
        packagingSizeName: 'test-package',
        packagingWeight: {
          weight: ((request.packageWeight?.weight || 0) * 0.1).toFixed(2),
          weightUnit: request.packageWeight?.weightUnit,
        },
        linearDimensions: {
          ...request.packagelinearDimensions,
        },
        shipOption: 'Standard',
        shipmentTags: [shipmentTag],
      },
      totalWeight: request.packageWeight,
    };
  };

  if (!Array.isArray(request.shipmentSourceAddresses) || request.shipmentSourceAddresses.length === 0) {
    if (request.shipmentSourceAddress) {
      request.shipmentSourceAddresses = [request.shipmentSourceAddress];
    }
  }

  for (const address of request.shipmentSourceAddresses || []) {
    payloads.push(createPayloadForShipment(address));
  }

  return payloads;
};
